export default __webpack_public_path__ + "static/media/Wine-white-grey.f554aadc.png";